import { COLORS } from 'helpers/globals'

export default {
  projectTitleEdit: {
    fontSize: '2rem',
    padding: '.3rem !important',
    borderColor: `${COLORS.quaternary} !important`,
    display: 'block',
    transition: 'all 0.30s ease-in-out',
    background: 'white !important',
    '&:hover': { borderColor: `${COLORS.quaternary} !important` },
    '&:focus': { borderColor: `${COLORS.primary} !important` }
  },
  inputGlow: {
    borderColor: `${COLORS.primary} !important`,
    boxShadow: '0 0 1px rgba(66, 139, 202, 1) !important'
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/ProjectTitle/style.js